// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609281213/js/" + chunkId + "." + {"44":"5e13820e","225":"f1855f12","481":"3221f6d1","486":"54d6157a","770":"a4857663"}[chunkId] + ".0.2961879358163447.chunk.js";
};